import { ReactNode } from "react"
import cn from "classnames"

import { Box, Img, Text } from "ui-kit/components-branded/index"
import style from "components/TelegramBlock/style.module.scss"

interface Props {
    className?: string
    button: ReactNode
}

export function TelegramBlock({ className, button }: Props) {
    return (
        <Box className={cn(style.container, className)} id="attach-tg">
            <div className={style.content}>
                <div className={style.description}>
                    <Text className={style.title}>Подключите уведомления в&nbsp;Telegram</Text>
                    <Text className={style.subtitle}>
                        Получайте сообщения о&nbsp;сессиях удобным способом.
                    </Text>
                </div>
                <Img className={style.image} src="client-account-telegram-account.svg" />
            </div>
            <div className="w-100 is-responsive is-hidden-desktop is-hidden-tablet">{button}</div>
            <div className="is-inline-block is-responsive is-hidden-mobile">{button}</div>
        </Box>
    )
}
